import _ from '../Trans';
import React, {useEffect, useRef, useState} from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter, Row, Col} from "reactstrap";
import Currency from './Currency'
import BarLoader from "react-spinners/BarLoader";
import {ValuationContainer} from './Valuation';
import { faChartLine, faUsersViewfinder, faPlus } from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ComparePlayers from "./CompareModal";
import Config from "../Config";

export default function PlayerInfoModal({showValue, modalData=null, showValueToggleHandler, addPlayerToSquadHandler}) {
    const [modalBody, setModalBody] = useState({__html: ""});
    const [show, setShow] = useState(false);
    const [barLoader, setBarLoader] = useState(false);

    const modalRef = useRef();

    const customToggle = function() {
        modalRef.current?.toggle();
    }

    useEffect(() => {
        if(showValue) {
            showValueToggleHandler();
            display();
        }
    }, [showValue]); // eslint-disable-line

    const toggle = () => setShow(!show)
    const display = () => {
        getAsobalData();
        setShow(true)
    }
    const hide = () => {
        setShow(false)
        showValueToggleHandler();
    }

    const sleep = function(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    const closed = function() {
        setModalBody({__html: ""})
    }

    const getAsobalData = function() {
        if(modalData?.infoLink === undefined || !modalData?.infoLink.includes("asobal")) {
            return;
        }
        setBarLoader(true);
        let customHeaders = new Headers();
        customHeaders.append('Content-Type','text/plain; charset=iso-8859-1');
        fetch(modalData.infoLink, customHeaders)
            .then(response => response.arrayBuffer())
            .then(buffer => new TextDecoder('iso-8859-1').decode(buffer))
            .then(txt => txt.replace('<link href="assets/css/main2425.css" rel="stylesheet" media="screen">', ''))
            .then(txt => txt.replace(/table-responsive/g, "w-100"))
            .then(txt => {
                let dom = document.createElement('div')
                let statsProcessor = document.getElementById('stats-processor');
                statsProcessor.appendChild(dom)
                dom.innerHTML = txt
            })
            .then(() => sleep(10))
            .then(() => document.getElementById('stats-processor').getElementsByClassName('col-lg-12')[0].innerHTML)
            .then(txt => txt.replace('table-responsive', 'w-100'))
            .then(txt => setModalBody({__html: txt}))
            .catch(err => console.log(err))
            .finally(() => setBarLoader(false))
    }

    let styleTd = {'fontSize': '1.2rem'}
    let stylePaddingRight = {'paddingRight': '15px', 'fontSize': '1.2rem'}
    const averagePointsText = _('Average valuation')
    const modalHeaderBackgroundStyle = {
        backgroundImage: 'linear-gradient(to bottom, rgba(255,255,255,0) 60%, rgba(255,255,255, 0.35) 70%, rgba(255,255,255, 0.8) 80%, rgba(255,255,255,1) 100%), url("' + modalData?.imageLink + '")'
    }

    return (
        <Modal isOpen={show} toggle={toggle} onClosed={closed} id="player-stats-modal" tabIndex="-1" role="dialog" fade={false} style={{color: 'black'}}>
            <ComparePlayers ref={modalRef} playerId={modalData?.playerId}/>
            <ModalHeader className="modal-header modal-header-stats">
                <div style={modalHeaderBackgroundStyle} className="modal-header-background" id="player-image-in-modal"></div>
                <div id="exampleModalLabel" className="h2 mb-0 modal-header-name">
                    {modalData?.name}
                </div>
                <button onClick={toggle} type="button"
                        className="close float-right text-right modal-header-close-button"
                        data-dismiss="modal" aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </ModalHeader>
            <ModalBody className="mb-2">
                <table className='w-100'>
                    <tbody>
                        <tr>
                            <td style={styleTd}>{_('Current price')}</td>
                            <td align='right' style={stylePaddingRight}>
                                <Currency value={modalData?.price}/>
                            </td>
                        </tr>
                        <tr>
                            <td style={styleTd}>{averagePointsText}</td>
                            <td align='right' style={stylePaddingRight}> {modalData?.valuationAverage ? modalData.valuationAverage : 0}
                            </td>
                        </tr>
                        <tr>
                            <td style={styleTd}>{_('Valuations')}</td>
                            <td>
                                <ValuationContainer valuations={modalData?.valuations}/>
                            </td>
                        </tr>
                        { modalData?.position_id === Config.GOALKEEPER && <tr><td style={styleTd}>{_('Stops ratio')}</td><td align='right' style={stylePaddingRight}> {modalData?.stoppedShotsRatio} </td></tr>}
                        <tr><td style={styleTd}>{_('Goal-scoring efficiency')}</td><td align='right' style={stylePaddingRight}> {modalData?.goalsRatio} </td></tr>
                        <tr>
                            <td style={styleTd}></td>
                            <td style={styleTd}></td>
                        </tr>
                        <tr>
                            <td style={styleTd} onClick={customToggle}></td>
                        </tr>
                    </tbody>
                </table>

                <div className="d-flex justify-content-between mt-4 w-100 text-center">
                    <div onClick={customToggle} className="link flex-fill" style={{maxWidth: "33%"}}>
                        <FontAwesomeIcon icon={faUsersViewfinder} className="stats-modal-icon-size"/><br/>
                        <span style={styleTd}>{_('Compare')}</span>
                    </div>
                    <div onClick={addPlayerToSquadHandler} data-player={modalData?.player} data-position={modalData?.position_id} className="link flex-fill" style={{maxWidth: "33%"}}>
                        <FontAwesomeIcon icon={faPlus} className="stats-modal-icon-size"/><br/>
                        <span style={styleTd}>{_('Buy')}</span>
                    </div>
                    <div className="link flex-fill" style={{maxWidth: "33%"}}>
                       { modalData?.infoLink.length > 0 && modalData?.infoLink.includes("asobal") &&
                            <a href={modalData?.infoLink} target='_blank' rel="noreferrer" className="font-weight-normal">
                               <FontAwesomeIcon icon={faChartLine} className="stats-modal-icon-size"/><br/>
                                <span style={styleTd}>{_('Stats at ASOBAL')}</span>
                            </a>
                       }
                    </div>
                </div>

                <div className="w-100 d-flex justify-content-center">
                    <BarLoader
                        color="#23a6da"
                        loading={barLoader}
                        width={400}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>

               <div className="panel-box padding-b">
                   <Row>
                        <Col xs={12} className="p-0 p-sm-3" dangerouslySetInnerHTML={modalBody}/>
                   </Row>
               </div>
                <div className="d-none" id="stats-processor"></div>
            </ModalBody>
            <ModalFooter>
                  <button type="button" className="btn btn-secondary pt-3 pb-3" data-dismiss="modal" onClick={hide}>
                      {_('Close')}
                  </button>
            </ModalFooter>
        </Modal>
    )
}
